// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","264":"component---src-templates-basic-page-js"}[chunkId] || chunkId) + "-" + {"108":"d59b5951f138089043ef","125":"06fa31c78be3b9f423cd","223":"8a35c1bc143f4313d210","264":"883ce5db87ecaa6f9d2f","452":"73cd47079db1724edf41"}[chunkId] + ".js";
};